export const ASSET_INFO_TEST_IDS = {
	ASSET_INFO: 'assetInfo',
	ASSET_INFO_BLOCK: 'assetInfoBlock',
	ASSET_INFO_BLOCK_NAME: 'assetInfoBlockName',
	NETWORK_ICON: 'networkIcon',
	HARDWARE_ICON: 'hardwareIcon',
	SOFTWARE_ICON: 'softwareIcon',
	CERTIFICATE_ICON: 'certificateIcon',
	DATAPOINT_INFO: 'dataPointInfo',
	DATAPOINT_LABEL: 'dataPointLabel',
	DATAPOINT_VALUE: 'dataPointValue',
	FIRMWARE_ICON: 'firmwareIcon'
};
